<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="md-title u-typography-color">
        Create New VIP Page
      </h4>
    </template>

    <template v-slot:body>
      <md-field>
        <label>Page Name</label>
        <md-input
          v-model.trim="pageName"
          type="text"
          placeholder="Enter page name"
          @keyup.enter="createPage"
        />
      </md-field>
      <span v-if="nameError" class="name-error">{{ nameError }}</span>
    </template>

    <template v-slot:footer>
      <div class="u-mr-xs ">
        <generic-button
          variation="grey"
          @click="close()"
        >
          Cancel
        </generic-button>
      </div>
      <generic-button
        variation="red"
        class="create-btn"
        @click="createPage"
      >
        Create
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import BaseModalComponent from '../modal/BaseModalComponent';
import GenericButton from '../buttons/GenericButton';

export default {
  name: 'VipPageCreateModalComponent',

  components: {
    BaseModalComponent,
    GenericButton,
  },

  props: {
    onAccept: {
      type: Function,
      required: false,
      default: () => {},
    },
    onClose: {
      type: Function,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      pageName: '',
      nameError: '',
    };
  },

  methods: {
    close() {
      this.onClose();
      this.$emit('close');
    },

    createPage() {
      this.nameError = '';

      if (!this.pageName || this.pageName === '') {
        this.nameError = 'Page name is required';
        return;
      }

      this.onAccept(this.pageName);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
  .create-btn {
    color: white;
  }

  .name-error {
    display: block;
    color: $red;
    font-size: 12px;
    margin-top: 5px;
    font-weight: 500;
  }

  .md-field {
    margin-bottom: 10px;
  }
</style>
